import React, { useContext, useEffect, useState } from "react";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import PersonaController from "./PersonaController";
import MainJobController from "./MainJobController";
import Monitoring from "../Monitoring";
import LlmController from "./LlmController";
import GeoMarketController from "./GeoMarketController";
import { useDispatch } from "react-redux";
import { fetchGeoMarkets } from "../../../../redux/actions/geoMarketsActions";
import { fetchPersonas } from "../../../../redux/actions/personasActions";
import { fetchCustomer } from "../../../../redux/actions/userActions";
import { AuthContext } from "../../../../context/auth-context";
import Spinner from "../../../../Component/Spinner/Spinner";
import { ENTITY_LABELS } from "../../../../utils/labelMapping";

const Controller = () => {
  const [loading, setLoading] = useState(true);

  const authCtx = useContext(AuthContext);
  const customerId = authCtx?.user?.customer_id || 0;

  const dispatch = useDispatch();

  const AccordionContent = [
    {
      key: "main",
      title: `${ENTITY_LABELS.brand}/${ENTITY_LABELS.product} & Competitors`, // ✅ display only
    },
    { key: "personas", title: "Personas" },
    { key: "llms", title: "Llms" },
    { key: "geo", title: "Geography & Markets" },
    { key: "metrics", title: "Metrics" },
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        await dispatch(fetchCustomer(customerId));
        await dispatch(fetchPersonas(customerId));
        await dispatch(fetchGeoMarkets(customerId));
      } catch (error) {
        console.error("Error fetching data", error);
        setLoading(false);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [dispatch, customerId]);

  // ✅ Switch on fixed key — never breaks regardless of label value
  const renderComponent = (key) => {
    switch (key) {
      case "main": return <MainJobController />;
      case "personas": return <PersonaController />;
      case "metrics": return <Monitoring />;
      case "llms": return <LlmController />;
      case "geo": return <GeoMarketController />;
      default: return null;
    }
  };

  if (loading) {
    return <Spinner />;
  }

  return (
    <>
      <Accordion defaultActiveKey="0">
        {AccordionContent.map((section, index) => (
          <Accordion.Item eventKey={index.toString()} key={index}>
            <Accordion.Header>
              <b>{section.title}</b>
            </Accordion.Header>
            <Accordion.Body>
              <Card key={index} className="mb-3">
                {/* ✅ Pass section.key for logic, section.title is only for display */}
                <Card.Body>{renderComponent(section.key)}</Card.Body>
              </Card>
            </Accordion.Body>
          </Accordion.Item>
        ))}
      </Accordion>
    </>
  );
};

export default Controller;